import { useState, useEffect, useRef, useCallback } from 'react';

interface UseComponentVisibleResult {
  ref: any;
  // | string
  // | ((instance: HTMLDivElement | null) => void)
  // | React.RefObject<HTMLDivElement>
  // | null
  // | undefined;
  isComponentVisible: boolean;
  setIsComponentVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function useComponentVisible(initialIsVisible: boolean): UseComponentVisibleResult {
  const [isComponentVisible, setIsComponentVisible] = useState(initialIsVisible);
  const ref = useRef(null);

  const handleClickOutside = useCallback((e: MouseEvent) => {
    if (ref.current && !(ref.current! as any).contains(e.target)) {
      setIsComponentVisible(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });

  return {
    ref,
    isComponentVisible,
    setIsComponentVisible,
  };
}
